import templateStr from 'text!./templates/guidance-link.html';

export default [function () {
    return {
        replace: true,
        restrict: 'A',
        template: templateStr
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/guidance/directives/GuidanceLink.js
// module id = 1224
// module chunks = 0